function projectData() {
  const projectsData = [
    {
      title: "portfolio Sample For Designer",
      finishPr: "08/08/2025",
      desc: "This portfolio sample showcases a designer's work, including various projects and design elements. It features a clean and modern layout, with a focus on visual storytelling and user experience. The portfolio is built using the latest web technologies to ensure responsiveness and performance.",
      skills: [
        "React",
        "TypeScript",
        "tailwindcss",
        "lenis",
        "aos",
        "react-hot-toast",
        "@emailjs/browser",
        "embla-carousel-react",
      ],
      img: "portfolio-sample.png",
      route: "portfolio-sample",
      linkDemo: "https://dalisraieb.github.io/portfolio-sample/",
    },
    {
      title: "School Management System",
      finishPr: "Feb 2024",
      desc: "This school management system includes features for managing teachers, students, schedules, pricing, invoices, expenses, and accounts. It offers drag-and-drop file management, interactive charts, and uses MUI for the interface. The system provides detailed statistics to streamline school administration.",
      skills: [
        "React",
        "TypeScript",
        "MUI",
        "Axios",
        "React-query",
        "React-table",
        "swiper",
        "React-hook-form",
        "react-router-dom",
        "html2Canvas",
        "Zustand",
        "React Table",
        "React-error-boundary",
        "aos",
        "jsPDF",
        "date-fns",
        "loadash",
        "apexcharts",
        "swiperJS",
      ],
      img: "Preview-ischool.png",
      route: "sms",
      linkDemo: "https://finpay-dashboard-ui.onrender.com/",
    },
    {
      title: "Dashboard For Booking Tickets",
      finishPr: "January 2024",
      desc: "This dashboard streamlines boat travel bookings with full CRUD functionality and authentication. Users can create, view, update, and cancel bookings, with security ensured through user authentication.",
      skills: [
        "React",
        "Tailwindcss",
        "React-hook-form",
        "React Table",
        "Axios",
        "React-router-dom",
        "React-error-boundary",
      ],
      img: "dash-booking.png",
      route: "dfbt",
      linkDemo: "https://trip-agency.onrender.com/",
    },
    {
      title: "Calendly Clone",
      finishPr: "December 2023",
      desc: "This project is a front-end clone of Calendly, enabling users to schedule appointments by selecting dates and times, entering personal information, and adding optional details. It provides confirmation or error messages upon submission. The application is built using React.js, Redux, and Tailwind CSS for a seamless user experience.",
      skills: ["React", "Tailwindcss", "Axios", "Redux"],
      img: "calendly.png",
      route: "cc",
      linkDemo: "https://calendly-clone-0msx.onrender.com/",
    },
    {
      title: "MOA TOOLKIT🏦",
      finishPr: "October 2023",
      desc: "The Moa Toolkit website demonstrates how Moa products can assist users in managing passwords, links, and database queries. Users can log in with their Gmail accounts to access and download these tools, ensuring security and personalized access. It's an informative resource for those looking to streamline their management tasks.",
      skills: [
        "Bootstrap",
        "Scss",
        "Vanilla javascript",
        "Express JS",
        "MongoDB",
        "Auth 2.0",
      ],
      img: "sketch.png",
      route: "moa",
      linkDemo: "https://moa-toolkit.onrender.com/",
    },
    {
      title: "Hotel and Tour Bookings ✈",
      finishPr: "September 2023",
      desc: "The Hotel and Tour Bookings website demonstrates its service efficiency, offering a variety of hotels and tours for reservation. Its user-friendly interface and comprehensive information empower travelers to make informed decisions and secure their preferred accommodations and tours effortlessly.",
      skills: ["Scss", "Vanila Javascript"],
      img: "Present.png",
      route: "hotel&tour",
      linkDemo: "https://camper-unqm.onrender.com/",
    },
    {
      title: "MUSIC PLATEFORME🎶",
      finishPr: "MAI 2023",
      desc: "Beat marketplaces like BeatStars and Airbit provide producers a platform to sell and buy beats, collaborate with artists, and negotiate licensing terms. These platforms simplify the process of monetizing beats and enable producers to reach a wider audience while offering artists a wide range of beats for their music projects.",
      skills: [
        "Scss",
        "Vanila Javascript",
        "Embed JS",
        "Passport.js",
        "Express JS",
        "Mongoose",
        "MongoDB",
      ],
      img: "Desktop.jpg",
      route: "music",
      linkDemo: "https://beats-0nwh.onrender.com/",
    },
    {
      title: "SCHEDULE AN AUDIT B2B🦻",
      finishPr: "September 2023",
      desc: `The "Schedule an Audit B2B" website simplifies B2B audit scheduling using Calendly integration. Users can effortlessly book audit appointments and explore the range of audit services available. It's a user-friendly platform enhancing efficiency in B2B auditing.`,
      skills: ["React", "TailwindCss", "Calendar"],
      img: "sketch-2.png",
      route: "Schedule",
      linkDemo: "https://better-product.netlify.app/",
    },
    {
      title: "TRAVEL DASHBOARD🧳",
      finishPr: "December 2022",
      desc: `The Travel Dashboard enables users to track service requests and responses, manage partner relationships, and view client feedback. This comprehensive platform streamlines travel management, offering a 360-degree view of operations and enhancing customer service.`,
      skills: ["Vanilla Scss", "Vanila Javascript"],
      img: "preview.png",
      route: "travel",
      linkDemo: "https://dashboard-travel.vercel.app/",
    },
    {
      title: "E-COMMERCE PEAKSPORT🛒",
      finishPr: "September 2022",
      desc: `Peaksport E-commerce Revamp is undergoing a comprehensive revamp to enhance its online shopping experience. Stay tuned for an improved platform, offering a better shopping journey for sports enthusiasts.`,
      skills: ["Scss", "Vanila Javascript"],
      img: "peak.png",
      route: "e-commerce",
      linkDemo: "https://peaky-sport.vercel.app/",
    },
  ];
  return projectsData;
}

export default projectData;
